// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ProcedureActionContextConfigurationBase_abstract } from './../abstract/SagaActionLib/ProcedureActionContextConfigurationBase_abstract';
export class ProcedureActionContextConfigurationBase extends ProcedureActionContextConfigurationBase_abstract {}
